import * as user from "./user";
import * as billing from "./billing";
import * as events from "./events";

export const UserAPI = new user.UserAPI();
export const EventsAPI = new events.EventsAPI();
export const BillingAPI = new billing.BillingAPI();


// WEBPACK FOOTER //
// ./src/api/index.ts